(() => {
  const decorate = () => {
    const tag = document.querySelector('[data-mc-catalog]')?.dataset.mcCurrentTag;
    if (tag) {
      document.querySelectorAll('#MainContent a[href*="/products/"]').forEach(link => {
        const url = new URL(link.href, location.href);
        if (url.origin !== location.origin) return;
        if (url.searchParams.get('mc_path') === tag) return;
        url.searchParams.set('mc_path', tag);
        link.href = url.pathname + url.search + url.hash;
      });
    }
    const requested = new URL(location.href).searchParams.get('mc_path');
    const paths = [...document.querySelectorAll('[data-mc-product-paths] [data-mc-tag]')];
    const selected = paths.find(path => path.dataset.mcTag === requested) || paths.find(path => path.dataset.mcParent === requested) || paths[0];
    paths.forEach(path => { path.hidden = path !== selected; });
  };
  decorate();
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; decorate(); });
  }).observe(document.querySelector('#MainContent') || document.body, {childList:true,subtree:true});
  addEventListener('pageshow', decorate);
})();
